import { ExportType } from '../../enums/export-type.enum';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { HttpUtils } from '../../utils/http.utils';
import { environment } from '../../../environments/environment';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class ExportApi {
  #httpClient: HttpClient = inject(HttpClient);
  readonly #apiUrl = environment.API_EWNIOSKI + '/export';

  exportApplication$(
    id: number | Set<number>,
    exportType: ExportType,
  ): Observable<HttpResponse<Blob>> {
    let httpParams: HttpParams;
    if (id instanceof Set) {
      httpParams = HttpUtils.toHttpParams({ id: Array.from(id) });
    } else {
      httpParams = HttpUtils.toHttpParams({ id: id.toString() });
    }
    httpParams = httpParams.append('exportType', exportType);
    return this.#httpClient.get(`${this.#apiUrl}`, {
      params: httpParams,
      observe: 'response',
      responseType: 'blob',
      withCredentials: true,
    });
  }
}
